// frontend/src/components/settings/SupplierSourceSelect.jsx
//
// Where suppliers and item→supplier links come from
// (core.models.Store.SupplierSource), as one picker. Store settings' Supplier
// setup card and the install setup step render it; the value reaches the
// endpoint as `sourcing.supplier_source`.

import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@mui/material';

// core.models.Store.SupplierSource, recommended-first for the select. The SET
// is pinned to the enum by core/test_i18n_dynamic_key_contracts.py through the
// `storeSettings.supplierSource_${source}` pattern in audit-i18n.config.json.
const SUPPLIER_SOURCES = ['per_vendor', 'manual'];

export default function SupplierSourceSelect({ value, onChange }) {
  const { t } = useTranslation();
  return (
    <TextField
      select
      label={t('storeSettings.supplierSourceLabel')}
      value={value}
      onChange={onChange}
      size="small"
      fullWidth
    >
      {SUPPLIER_SOURCES.map((source) => (
        <MenuItem key={source} value={source}>
          {t(`storeSettings.supplierSource_${source}`)}
        </MenuItem>
      ))}
    </TextField>
  );
}
